import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Loading, Message } from "element-ui";

console.log(process.env);

let loadingInstance = null;
let timeout;
const delay = 200;
function clear() {
  clearTimeout(timeout);
  if (loadingInstance) {
    loadingInstance.close();
  }
}

let http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 20000,
});

http.interceptors.request.use(
  function(config) {
    config = {
      showLoading: true,
      showMessage: true,
      useToken: true,
      ...config,
    };

    if (config.showLoading) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        loadingInstance = Loading.service({
          fullscreen: true,
          text: "请求中...",
        });
      }, delay);
    }

    let token = store.state.token;
    if (config.useToken && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function(response) {
    clear();

    if (!response.data.success) {
      Message({
        message: response.data.msg,
        type: "error",
      });

      return Promise.reject(response.data);
    }

    return response.data.data;
  },
  function(error) {
    console.log(error.response);
    clear();

    if (error.response.status == 401 || error.response.status == 403) {
      router.push("/login");
    }

    Message({
      message: error.response.data.msg,
      type: "error",
    });

    return Promise.reject(error);
  }
);

export default http;
